import Icon from './Icon';

const Calendar = (props) => (
  <Icon
    {...props}
    path="M66.667 14.133h-5.567v-4.133c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v0 4.133h-32.5v-4.133c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v0 4.133h-5.267c-1.385 0.019-2.5 1.146-2.5 2.533 0 0 0 0 0 0v0 53.333c0.019 1.373 1.127 2.481 2.498 2.5h53.335c1.373-0.019 2.481-1.127 2.5-2.498v-53.335c0-0 0-0 0-0 0-1.387-1.115-2.514-2.498-2.533h-0.002zM64.167 19.133v9.333h-48.333v-9.333zM15.833 67.5v-34.167h48.333v34.167z M41.667 43.333h-3.333c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5v0h3.333c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5v0z M56.667 43.333h-3.333c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5v0h3.333c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5v0z M27.267 43.333h-3.333c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5v0h3.333c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5v0z"
  />
);

export default Calendar;
